import React from 'react';
import { Rail } from './chrome/Rail';
import { TopBar } from './chrome/TopBar';
import { Deploys } from './screens/Deploys';
import { Logs } from './screens/Logs';
import { Machines } from './screens/Machines';
import { Packages } from './screens/Packages';
import { People } from './screens/People';
import { Studios } from './screens/Studios';
import { Overview } from './screens/Overview';
import { Posture } from './screens/Posture';
import { useEnvStore } from './store/envStore';
import { useUi } from './store/uiStore';

export function App() {
  const load = useEnvStore((s) => s.load);
  const screen = useUi((s) => s.screen);
  React.useEffect(() => { void load(); }, [load]);
  return (
    <>
      <TopBar />
      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <Rail />
        <div className="pd-main">
          {screen === 'overview' && <Overview />}
          {screen === 'people' && <People />}
          {screen === 'studios' && <Studios />}
          {screen === 'machines' && <Machines />}
          {screen === 'packages' && <Packages />}
          {screen === 'deploys' && <Deploys />}
          {screen === 'logs' && <Logs />}
          {screen === 'posture' && <Posture />}
        </div>
      </div>
    </>
  );
}
